import React from "react";
import { useMediaQuery } from "react-responsive";
import { HashRouter, Switch, Route } from "react-router-dom";
import "./App.scss";
import { closeModal, copyToClipboard, Modals, openModal } from "./Components/Modals";

import HomePage from "./Pages/Home";
import CommPage from "./Pages/Commissions";

import Toasts from "./Components/Toasts";
import HeaderButton from "./Components/HeaderButton";

import HomeIcon from "./Icons/Home.svg";
import CommIcon from "./Icons/Commissions.svg";
import FurrIcon from "./Icons/FurAffinity.svg";
import DeviIcon from "./Icons/DeviantArt.svg";
import ToyHIcon from "./Icons/ToyHouse.svg";
import DiscIcon from "./Icons/Discord.svg";
import SbarIcon from "./Icons/Sidebar.svg";

import Logo from "./Icons/Logo.png";

class Header extends React.Component {
	state = { sidebarOpen: false };

	render() {
		const { isMobile } = this.props;

		return (
			<header className={"Header " + (this.state.sidebarOpen ? "Active" : "Inactive")}>
				<div className="HeaderButtons"> 
					{ isMobile ? (<HeaderButton icon={SbarIcon} className="RouteButton"
						onClick={() => this.setState({ sidebarOpen: !this.state.sidebarOpen })}/>) : null }
					<HeaderButton icon={HomeIcon} href="#/" onClick={() => this.setState({ sidebarOpen: false })}>Home</HeaderButton>
					<HeaderButton icon={CommIcon} href="#/commissions" scale={0.8} onClick={() => this.setState({ sidebarOpen: false })}>Commissions</HeaderButton>
					<HeaderButton icon={DiscIcon} scale={0.8} onClick={() => copyToClipboard("SerXia#2092")}>Copy my Discord tag</HeaderButton>
					<HeaderButton icon={DeviIcon} href="https://www.deviantart.com/serx1a" scale={0.5} iconStyle={{ marginLeft: 7 }}>My DeviantArt</HeaderButton>
					<HeaderButton icon={ToyHIcon} href="https://toyhou.se/SerXia" scale={0.85}>My Toyhou.se</HeaderButton>
					{/* <HeaderButton icon={FurrIcon} href="https://www.furaffinity.net/user/serx1a/" iconStyle={{ marginTop: -3 }}>My FurAffinity</HeaderButton> */}
				</div>

				<span className="HeaderMain">
					<img className="Logo" src={Logo} width={35}/>
					Surreal Studio
				</span>
			</header>
		);
	}
}

export default function App() {
	const isMobile = useMediaQuery({ query: "(max-width: 1224px)" });

	App.showNotice = function(text) {
		openModal(
			<div className="ClipboardModal" onClick={() => closeModal()}>
				<span>
					{ text }
				</span>
			</div>
		);
	};

	return (
		<div className={"App " + (isMobile ? "Mobile" : "Desktop")}>
			<div>
				<Header isMobile={isMobile}/>

				<div className="Main">
					<HashRouter basename="/">
						<Switch>
							<Route exact path="/" component={HomePage}/>
							<Route path="/commissions" component={CommPage}/>
						</Switch>
					</HashRouter>
				</div>

				<footer className="Footer">
					<span>
						<a href="https://fontawesome.com/license">Icon License</a> | 
						Copyright © 2020 Surreal Studio | 
						Site by <a href="https://metalloriff.github.io/toms-discord-stuff/#/contact">Metalloriff</a>
					</span>
				</footer>
			</div>

			<Modals/>
			<Toasts/>
		</div>
	);
}